import { AbstractLocaleMessageObject } from "@/i18n/AbstractLocaleMessageObject"

import { ICommonPagingControlParts } from "%%/labels/interfaces"

export class CommonPagingControlPartsEn extends AbstractLocaleMessageObject implements ICommonPagingControlParts {
  // 50 <= count <= 200 で必ず複数形なので複数化対応しない
  readonly tableDropDownPageCount = "Displaying {count} items."
}
